module.exports = __webpack_public_path__ + "static/media/search.1f6a4263.svg";